function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import cx from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { Button, Dialog } from "./..";
import Accordion from "./components/Accordion";
import HeaderTop from "./components/HeaderTop";
import LoginPop from "./components/LoginPop";
import Menu from "./components/Menu";
import Mobile from "./components/Mobile";
import MobileNavigation from "./components/MobileNavigation";
import TextPanel from "./components/TextPanel";
import "./index.less";
import { getLink, splitArray } from "./utils";
var Header = function Header(props) {
  var logo = props.logo,
    _props$cartNum = props.cartNum,
    cartNum = _props$cartNum === void 0 ? 0 : _props$cartNum,
    showCount = props.showCount,
    _props$menus = props.menus,
    menus = _props$menus === void 0 ? [] : _props$menus,
    _props$loginInfo = props.loginInfo,
    loginInfo = _props$loginInfo === void 0 ? {} : _props$loginInfo,
    _props$logoutText = props.logoutText,
    logoutText = _props$logoutText === void 0 ? '' : _props$logoutText,
    superCareInfo = props.superCareInfo,
    _props$headerTop = props.headerTop,
    headerTop = _props$headerTop === void 0 ? {} : _props$headerTop,
    _props$changeLangDial = props.changeLangDialog,
    changeLangDialog = _props$changeLangDial === void 0 ? {} : _props$changeLangDial,
    _props$goHomeDialog = props.goHomeDialog,
    goHomeDialog = _props$goHomeDialog === void 0 ? {} : _props$goHomeDialog,
    _props$logoutDialog = props.logoutDialog,
    logoutDialog = _props$logoutDialog === void 0 ? {} : _props$logoutDialog,
    _props$originUrl = props.originUrl,
    originUrl = _props$originUrl === void 0 ? '' : _props$originUrl,
    onLogout = props.onLogout,
    onLiClick = props.onLiClick,
    goHome = props.goHome,
    headerTabs = props.headerTabs,
    className = props.className;
  var superAgentText = headerTop.superAgentText,
    langText = headerTop.langText,
    onChangeLang = headerTop.onChangeLang,
    onShoppingCart = headerTop.onShoppingCart,
    onSuperAgent = headerTop.onSuperAgent;
  var classes = cx('iron-header-fixed', className);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showLogin = _useState2[0],
    setShowLogin = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showMobile = _useState4[0],
    setShowMobile = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isReset = _useState6[0],
    setIsReset = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    currentMenu = _useState8[0],
    setCurrentMenu = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    arrayA = _useState10[0],
    setArrayA = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    arrayB = _useState12[0],
    setArrayB = _useState12[1];
  var previousScrollTop = useRef(0);
  var ref = React.useRef(null);
  var handleActive = function handleActive(activeKey) {
    var activeMenu = menus.find(function (item) {
      return item.value === activeKey;
    });
    setCurrentMenu(activeMenu);
    var _splitArray = splitArray((activeMenu === null || activeMenu === void 0 ? void 0 : activeMenu.children) || []),
      _splitArray2 = _slicedToArray(_splitArray, 2),
      arrayAA = _splitArray2[0],
      arrayBB = _splitArray2[1];
    setArrayA(arrayAA);
    setArrayB(arrayBB);
    setIsReset(false);
  };
  var handleOpenMobile = function handleOpenMobile() {
    setShowMobile(true);
    // 操作移动版菜单时 关闭登录弹窗
    setShowLogin(false);
  };
  var handleCloseMobile = function handleCloseMobile() {
    setShowMobile(false);
    setShowLogin(false);
  };
  var menuReset = function menuReset() {
    setCurrentMenu(null);
    setIsReset(true);
  };
  var handleScroll = function handleScroll() {
    var headerTop = document.getElementById('iron-header-top');
    var header = document.getElementById('iron-header');
    var currentScrollPosition = window.scrollY;
    var currentWidth = window.innerWidth || document.documentElement.clientWidth;
    if (currentScrollPosition < previousScrollTop.current) {
      if (headerTop) {
        var _headerTop$style;
        headerTop === null || headerTop === void 0 || (_headerTop$style = headerTop.style) === null || _headerTop$style === void 0 || _headerTop$style.setProperty('margin-top', '0');
      }
      if (header && currentWidth <= 768) {
        var _header$style;
        header === null || header === void 0 || (_header$style = header.style) === null || _header$style === void 0 || _header$style.setProperty('margin-top', '0px');
      }
    } else {
      if (headerTop) {
        var _headerTop$style2;
        headerTop === null || headerTop === void 0 || (_headerTop$style2 = headerTop.style) === null || _headerTop$style2 === void 0 || _headerTop$style2.setProperty('margin-top', '-40px');
      }
      if (header && currentWidth <= 768) {
        var _header$style2;
        header === null || header === void 0 || (_header$style2 = header.style) === null || _header$style2 === void 0 || _header$style2.setProperty('margin-top', '-80px');
      }
    }
    previousScrollTop.current = currentScrollPosition;
  };

  /** 切换语言控制 */
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    changeLangIsOpen = _useState14[0],
    setChangeLangIsOpen = _useState14[1];
  var handleShowChangeLangModal = function handleShowChangeLangModal() {
    if (changeLangDialog.isOpen) {
      //需要显示弹窗的时候
      setChangeLangIsOpen(true);
    } else {
      if (onChangeLang) {
        onChangeLang();
      }
    }
  };

  /** 回首页弹窗控制 */
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    goHomeIsOpen = _useState16[0],
    setGoHomeIsOpen = _useState16[1];
  var handleShowHomePageModal = function handleShowHomePageModal() {
    if (goHomeDialog.isOpen) {
      //需要显示弹窗的时候
      setGoHomeIsOpen(true);
    } else {
      if (goHome) {
        goHome();
      }
    }
  };

  /** 用户登出弹窗控制 */
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    logoutIsOpen = _useState18[0],
    setLogoutIsOpen = _useState18[1];
  var handleShowLogoutModal = function handleShowLogoutModal() {
    if (logoutDialog.isOpen) {
      //需要显示弹窗的时候
      setLogoutIsOpen(true);
    } else {
      if (onLogout) {
        onLogout();
      }
    }
  };
  var handleLiClick = function handleLiClick(item) {
    if (onLiClick) {
      onLiClick(item);
    }
  };
  var handleOpenLogin = function handleOpenLogin() {
    setShowLogin(true);
    menuReset();
  };

  //点击header外部，隐藏登录弹窗
  var handleOutsideClick = function handleOutsideClick(e) {
    var containerEle = ref.current;
    if (containerEle && !containerEle.contains(e.target)) {
      setShowLogin(false);
      menuReset();
    }
  };
  useEffect(function () {
    // 注册事件
    document.addEventListener('mousedown', handleOutsideClick);
    //移动端 手指触摸屏幕触发
    document.addEventListener('ontouchstart', handleOutsideClick);
    // 注册滚动事件
    document.addEventListener('scroll', handleScroll);
    return function () {
      // 移除注册的事件
      document.removeEventListener('mousedown', handleOutsideClick);

      //移动端 手指触摸屏幕触发
      document.removeEventListener('ontouchstart', handleOutsideClick);
      document.removeEventListener('scroll', handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    // 切换语言之后，重新设置展开的菜单数据
    if (menus) {
      handleActive((currentMenu === null || currentMenu === void 0 ? void 0 : currentMenu.value) || 0);
    }
  }, [JSON.stringify(menus)]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: classes
  }, /*#__PURE__*/React.createElement(HeaderTop, {
    cartNum: cartNum,
    showCount: showCount,
    superAgentText: superAgentText,
    langText: langText,
    onChangeLang: handleShowChangeLangModal,
    onShoppingCart: onShoppingCart,
    onSuperAgent: onSuperAgent,
    tabs: headerTabs,
    id: "iron-header-top",
    originUrl: originUrl
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('iron-header', className),
    "data-full": Boolean(currentMenu),
    id: "iron-header"
    // onMouseLeave={handleReset}
  }, /*#__PURE__*/React.createElement("div", {
    className: "iron-header-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "iron-header-content "
  }, /*#__PURE__*/React.createElement("div", {
    className: "iron-header-left "
  }, /*#__PURE__*/React.createElement("div", {
    className: "iron-header-logo",
    onClick: handleShowHomePageModal
  }, /*#__PURE__*/React.createElement("div", {
    id: "logo"
  }, logo)), /*#__PURE__*/React.createElement(Menu, {
    menus: menus,
    activeKey: currentMenu === null || currentMenu === void 0 ? void 0 : currentMenu.value,
    onActive: handleActive,
    reset: isReset,
    originUrl: originUrl
  })), /*#__PURE__*/React.createElement("div", {
    className: "iron-header-right "
  }, /*#__PURE__*/React.createElement(Button, {
    className: "login-btn",
    size: "large",
    type: "primary",
    onClick: handleOpenLogin
  }, loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.label), /*#__PURE__*/React.createElement(MobileNavigation, {
    cartNum: cartNum,
    showCount: showCount,
    openMobile: handleOpenMobile,
    closeMobile: handleCloseMobile,
    onShoppingCart: onShoppingCart,
    onLogin: handleOpenLogin
  }))), showLogin && /*#__PURE__*/React.createElement(LoginPop, {
    loginInfo: loginInfo,
    logoutText: logoutText,
    originUrl: originUrl,
    Logout: handleShowLogoutModal,
    onClick: handleLiClick
  })), currentMenu && /*#__PURE__*/React.createElement("div", {
    className: "iron-menu"
  }, /*#__PURE__*/React.createElement("div", {
    className: "iron-menu-main"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "iron-menu-box iron-menu-left"
  }, arrayA.map(function (item) {
    return /*#__PURE__*/React.createElement(Accordion, {
      key: item === null || item === void 0 ? void 0 : item.value,
      header: {
        label: item === null || item === void 0 ? void 0 : item.label,
        icon: item === null || item === void 0 ? void 0 : item.icon,
        href: getLink(item === null || item === void 0 ? void 0 : item.href, originUrl),
        target: item === null || item === void 0 ? void 0 : item.target
      },
      lock: item === null || item === void 0 ? void 0 : item.lock,
      foldState: item === null || item === void 0 ? void 0 : item.foldState
    }, /*#__PURE__*/React.createElement(TextPanel, {
      subMenus: item === null || item === void 0 ? void 0 : item.children,
      originUrl: originUrl
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: "iron-menu-solid"
  }), /*#__PURE__*/React.createElement("div", {
    className: "iron-menu-box iron-menu-right"
  }, arrayB.map(function (item) {
    return /*#__PURE__*/React.createElement(Accordion, {
      key: item === null || item === void 0 ? void 0 : item.value,
      header: {
        label: item === null || item === void 0 ? void 0 : item.label,
        icon: item === null || item === void 0 ? void 0 : item.icon,
        href: getLink(item === null || item === void 0 ? void 0 : item.href, originUrl),
        target: item === null || item === void 0 ? void 0 : item.target
      },
      lock: item === null || item === void 0 ? void 0 : item.lock,
      foldState: item === null || item === void 0 ? void 0 : item.foldState
    }, /*#__PURE__*/React.createElement(TextPanel, {
      subMenus: item === null || item === void 0 ? void 0 : item.children,
      originUrl: originUrl
    }));
  }), ((currentMenu === null || currentMenu === void 0 ? void 0 : currentMenu.label) === 'Claims' || (currentMenu === null || currentMenu === void 0 ? void 0 : currentMenu.label) === '索償') && superCareInfo && (superCareInfo === null || superCareInfo === void 0 ? void 0 : superCareInfo.label) && /*#__PURE__*/React.createElement("div", {
    className: "iron-SuperCase-box",
    style: {
      backgroundImage: "url(".concat(superCareInfo === null || superCareInfo === void 0 ? void 0 : superCareInfo.backgroundImage, ")")
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: superCareInfo === null || superCareInfo === void 0 ? void 0 : superCareInfo.href,
    target: superCareInfo === null || superCareInfo === void 0 ? void 0 : superCareInfo.target
  }, /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: superCareInfo === null || superCareInfo === void 0 ? void 0 : superCareInfo.label
    }
  }))))))), /*#__PURE__*/React.createElement(Mobile, {
    menus: menus,
    visible: showMobile,
    superCareInfo: superCareInfo,
    originUrl: originUrl,
    superAgentText: superAgentText,
    langText: langText,
    onChangeLang: handleShowChangeLangModal,
    onSuperAgent: onSuperAgent,
    tabs: headerTabs
  }))), /*#__PURE__*/React.createElement(Dialog, {
    id: (changeLangDialog === null || changeLangDialog === void 0 ? void 0 : changeLangDialog.id) || 'header-change-lang',
    isOpen: changeLangIsOpen,
    title: changeLangDialog === null || changeLangDialog === void 0 ? void 0 : changeLangDialog.title,
    okTxt: changeLangDialog === null || changeLangDialog === void 0 ? void 0 : changeLangDialog.okTxt,
    cancelTxt: changeLangDialog === null || changeLangDialog === void 0 ? void 0 : changeLangDialog.cancelTxt,
    isShowFoot: true,
    onClose: function onClose() {
      return setChangeLangIsOpen(false);
    },
    onCancel: function onCancel() {
      return setChangeLangIsOpen(false);
    },
    onOk: function onOk() {
      // setChangeLangIsOpen(false);
      if (onChangeLang) {
        onChangeLang();
      }
    },
    closeOpen: false
  }, changeLangDialog === null || changeLangDialog === void 0 ? void 0 : changeLangDialog.children), /*#__PURE__*/React.createElement(Dialog, {
    id: (goHomeDialog === null || goHomeDialog === void 0 ? void 0 : goHomeDialog.id) || 'header-go-home',
    isOpen: goHomeIsOpen,
    title: goHomeDialog === null || goHomeDialog === void 0 ? void 0 : goHomeDialog.title,
    okTxt: goHomeDialog === null || goHomeDialog === void 0 ? void 0 : goHomeDialog.okTxt,
    cancelTxt: goHomeDialog === null || goHomeDialog === void 0 ? void 0 : goHomeDialog.cancelTxt,
    isShowFoot: true,
    onClose: function onClose() {
      return setGoHomeIsOpen(false);
    },
    onCancel: function onCancel() {
      return setGoHomeIsOpen(false);
    },
    onOk: function onOk() {
      setGoHomeIsOpen(false);
      if (goHome) {
        goHome();
      }
    },
    closeOpen: false
  }, goHomeDialog === null || goHomeDialog === void 0 ? void 0 : goHomeDialog.children), /*#__PURE__*/React.createElement(Dialog, {
    id: (logoutDialog === null || logoutDialog === void 0 ? void 0 : logoutDialog.id) || 'header-logout',
    isOpen: logoutIsOpen,
    title: logoutDialog === null || logoutDialog === void 0 ? void 0 : logoutDialog.title,
    okTxt: logoutDialog === null || logoutDialog === void 0 ? void 0 : logoutDialog.okTxt,
    cancelTxt: logoutDialog === null || logoutDialog === void 0 ? void 0 : logoutDialog.cancelTxt,
    isShowFoot: true,
    onClose: function onClose() {
      return setLogoutIsOpen(false);
    },
    onCancel: function onCancel() {
      return setLogoutIsOpen(false);
    },
    onOk: function onOk() {
      setLogoutIsOpen(false);
      if (onLogout) {
        onLogout();
      }
    },
    closeOpen: false
  }, logoutDialog === null || logoutDialog === void 0 ? void 0 : logoutDialog.children));
};
export default Header;